define('components/handlers/follow-query',[
    'jquery',
    '../util/tool-menu',
    '../util/reload-fragments',
    '../handlers/analytics'
],function(
    jQuery,
    toolMenu,
    reload,
    analytics
){
    $.extend(companyInfo.handlers,{

        'follow-query': function( e ){

            e.preventDefault();

            var $el = jQuery(this);
            var serviceUrl = $el.data('follow-url');
            var currentQuery = $el.data('follow-query');
            var defaultName = $el.data('follow-name');
            var atElement =  $el.find('.ico');

            toolMenu.show( getNameInterface( serviceUrl, currentQuery, defaultName, atElement ), atElement );

        }

    });

    var nameInterfaceString = ''.concat(
        '<div>',
            '<span class="title">' + companyInfo.labels.nameForQuery + '</span>',
            '<div class="form-element"><input type="text" class="input" maxlength="75" data-field-id="addquerybox" placeholder="' + companyInfo.labels.nameIsMandatory + '" required /></div>',
            '<div class="form-element"><input type="button" data-field-id="addquerysubmit" class="submit" value="'+companyInfo.labels.save+'"/></div>',
        '<div>'
    );

    var resultString = '<div class="form-element"><p>{message}</p></div>';

    var pending,valid;

    function getNameInterface(serviceUrl, currentQuery, defaultName, atElement){
        var nameInterface = jQuery( nameInterfaceString );
        var nameField = nameInterface.find('input[type=text]');
        var button = nameInterface.find('.submit');
        nameField.val(defaultName);
        valid = defaultName && (defaultName.toString()).replace(/\s/g,'').length;
        button.prop('disabled', !valid);
        nameInterface.on('click','.submit',function(e){
            if ( !valid || pending || !currentQuery ) return;
            var icon = atElement;
            pending = true;
            nameField[0].disabled = true;
            nameInterface.addClass('submitted');
            doRequest( serviceUrl, nameField, currentQuery, icon );
        });
        nameField.on('input keyup change',function(e){
            valid = !!this.value.replace(/\s/g,'').length;
            nameField.toggleClass('invalid', !valid);
            button.prop('disabled', !valid);
        });
        return nameInterface;
    }


    function doRequest( serviceUrl, nameField, currentQuery, icon){
        var originalClassName = icon[0].className;
        icon[0].className = "ico ico-spinner ico-spin";
        jQuery.ajax({
            url: serviceUrl,
            type: 'POST',
            data: {
                query: currentQuery,
                name: nameField.val()
            }
        }).done(function(result){
            toolMenu.show(resultString.replace('{message}',result), icon);
            reload('follow');
            analytics(['user settings', 'add search term']);
            setTimeout(function(){
                toolMenu.hide();
            },2000);
        }).always(function(){
            pending = false;
            icon[0].className = originalClassName;
        }).fail(function(){
            toolMenu.show(resultString.replace('{message}','Something went wrong, try again later!'),icon);
        });
    }


});

